import { Component, OnInit } from '@angular/core';

@Component({
  selector:    'app-bankia-error',
  templateUrl: './bankia-error.component.html',
  styleUrls:   ['./bankia-error.component.scss']
})
export class BankiaErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
